import { BottomSheetIllustrationContent, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export interface ActionNotFoundContentProps {
  action: "clock-in" | "clock-out";
  onTryAgain: (() => void) | undefined;
  onSkipAction: () => void;
  onClose?: () => void;
}

function getActionTexts(action: "clock-in" | "clock-out"): {
  title: string;
  description1: string;
  description2: string;
  skipButton: string;
} {
  switch (action) {
    case "clock-in": {
      return {
        title: "Clock in not found",
        description1: "Please clock in at the time clock to continue.",
        description2: "If you need help clocking in, please ask an admin at the front desk.",
        skipButton: "Skip clock in",
      };
    }

    case "clock-out": {
      return {
        title: "Clock out not found",
        description1: "Please clock out at the time clock to continue.",
        description2: "If you need help clocking out, please ask an admin at the front desk.",
        skipButton: "Skip clock out",
      };
    }

    default: {
      return action satisfies never;
    }
  }
}

export function ActionNotFoundContent(props: ActionNotFoundContentProps) {
  const { action, onTryAgain, onSkipAction, onClose } = props;
  const texts = getActionTexts(action);

  return (
    <>
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="error"
        title={texts.title}
        description={
          <Stack gap={5}>
            <Text
              semibold
              variant="body1"
              sx={(theme) => ({ color: theme.palette.text.secondary })}
            >
              {texts.description1}
            </Text>
            <Text
              semibold
              variant="body1"
              sx={(theme) => ({ color: theme.palette.text.secondary })}
            >
              {texts.description2}
            </Text>
          </Stack>
        }
      />
      <DialogFooter orientation="vertical" onClose={onClose}>
        {isDefined(onTryAgain) && (
          <Button
            fullWidth
            size="large"
            onClick={() => {
              onTryAgain();
            }}
          >
            Try again
          </Button>
        )}
        <Button
          fullWidth
          variant="destructive"
          size="large"
          onClick={() => {
            onSkipAction();
          }}
        >
          {texts.skipButton}
        </Button>
      </DialogFooter>
    </>
  );
}
